// extracted by mini-css-extract-plugin
export default {"mask":"popup_mask__AYdAm","popup":"popup_popup__lBpN+","bg":"popup_bg__YI2QM","openBtn":"popup_openBtn__Zkutg","closeBtn":"popup_closeBtn__tDvnj"};